import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const GoogleMapsWidget: WidgetRegistryEntry = {
  name: "GoogleMaps",
  configuration: () => import("./configuration").then((m) => m.GoogleMapsWidgetConfiguration),
  component: () => import("./google-maps-widget.component").then((m) => m.GoogleMapsWidgetComponent)
};
